const getters = {
  sidebar: (state) => state.app.sidebar,
  size: (state) => state.app.size,
  progress: (state) => state.app.requestProgress,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  user: (state) => {
    // console.log(state);
    return {
      userId: state.user.id,
      username: state.user.username,
      roles: state.user.roles,
      permissions: state.user.permissions,
      avatar: state.user.avatar,
      email: state.user.email,
      name: {
        first: state.user.firstName,
        last: state.user.lastName,
      },
    };
  },
  users: (state) => state.users.users,
  roles: (state) => state.users.roles,
  permissions: (state) => state.users.permissions,

  allRoutes: (state) => state.permission.allRoutes,
  generatedRoutes: (state) => state.permission.addedRoutes,
  routesGenerated: (state) => state.permission.routesGenerated,

  indicators: (state) => state.dashboard.indicators,
  datasources: (state) => state.dashboard.datasources,
  valueTypes: (state) => state.dashboard.valueTypes,
  locations: (state) => state.dashboard.locations,
  dashboards: (state) => state.dashboard.dashboards,
  data: (state) => state.dashboard.data,
  dashboardError: (state) => state.dashboard.error,
};

export default getters;
